var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('c-loading'):_c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.widgets),function(widget,key){return _c('v-widget',{key:key,attrs:{"c-widget":widget}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }